/**
 * Stand-in for a screen that a later stage will build. Keeps the shell walkable
 * end to end today — every menu item leads somewhere honest, saying which stage
 * fills it in, rather than a dead link or a blank page.
 */
export function PlaceholderPage({ title, stage }: { title: string; stage: number }) {
  return (
    <div className="p-6">
      <h1 className="text-xl font-bold text-slate-800">{title}</h1>
      <div className="mt-4 inline-flex items-center gap-2 text-sm text-slate-500 bg-slate-100 border border-slate-200 rounded-md px-3 py-2">
        <span className="font-mono text-xs bg-slate-200 rounded px-1.5 py-0.5">Etap {stage}</span>
        Ta część powstanie w Etapie {stage}.
      </div>
    </div>
  )
}
